
//copia para a area de transferencia
function copyToClipboard(text) {
    var dummy = document.createElement("textarea");
    document.body.appendChild(dummy);
    dummy.value = text;
    dummy.select();
    document.execCommand("copy");
    document.body.removeChild(dummy);
}

// Seleciona todos os elementos com a classe 'tt'
const tooltipLeft = document.querySelectorAll('.tooltip-left');
tooltipLeft.forEach(el => {
    new bootstrap.Tooltip(el, {
        placement: 'left',
        trigger: 'hover'
    });
});

// Seleciona todos os elementos com a classe 'tt'
const tooltipTop = document.querySelectorAll('.tooltip-top');
tooltipTop.forEach(el => {
    new bootstrap.Tooltip(el, {
        placement: 'top',
        trigger: 'hover'
    });
});

// for show password 
let createpassword = (type, ele) => {
    document.getElementById(type).type = document.getElementById(type).type == "password" ? "text" : "password"
    let icon = ele.childNodes[0].classList
    let stringIcon = icon.toString()
    if (stringIcon.includes("ri-eye-line")) {
        ele.childNodes[0].classList.remove("ri-eye-line")
        ele.childNodes[0].classList.add("ri-eye-off-line")
    }
    else {
        ele.childNodes[0].classList.add("ri-eye-line")
        ele.childNodes[0].classList.remove("ri-eye-off-line")
    }
}